<template>
<div>

    <wewHeader></wewHeader>

    
    <section class="success pad-t-90 pad-b-80">
        <div class="container">
        <h1 class="text-center pad-b-30">LOOKING GOOD!</h1>
        <div class="w-1-6 hidden-xs"></div>
        <div class="w-1 w-sm-2-3">
            <h2 class="color-blue car-title text-center">Your vehicle details are being passed to one of our experts and we'll be in touch soon</h2>
        </div>
        <div class="success-message">

            <div class="text-center pad-t-40">
                <img src="../assets/images/green-tick.png">
            </div>

        </div>
        </div>

    </section>

     <wewFooterWhite></wewFooterWhite>

</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewFooterWhite from '@/components/wew-footer-white'

export default {
    name: 'success',
    components: {
        wewHeader,
        wewFooterWhite
    },
 data() {
        return {
            
        }
    },
    beforeMount() {
        this.$store.dispatch('anonLogout')
    }
}
</script>

<style>

h2.car-title{
    text-transform: uppercase;
    font-size: 40px;
    line-height: 40px;
}

.reg-title{
    background:#CCCCCC;
    border-radius: 30px;
    padding: 2px 18px;
    display: inline-block;
    font-size: 18px;
    font-weight:800;
}
</style>
